import React, { Component } from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import { translate } from 'react-i18next';
import cx from 'classnames';

@translate(['dashboard-sidebar'], { wait: true })
@onClickOutside
export class IgnitionAutorun extends Component {
  handleClickOutside(e) {
    e.preventDefault();
    e.stopPropagation(e);
    this.props.onClickOutside(e);
  }
  render() {
    const { currentDevice, setWebastoOn, setSeconds, t } = this.props;

    return (
      <div className="control-button__drop-down aside__drop-down" style={{ top: 'calc(100% - 10px)', left: 15, right: 15, opacity: 1 }}>
        <div className="aside__drop-down__panel" style={{ borderBottom: 0 }}>
          <a
            onClick={e => setSeconds(e, true)}
            className={cx('minus quantity-btn', { disable: currentDevice.autorunEngineDelayInSeconds === 120 })}
          />
          <div className="box">
            <input className="duration-input" value={Math.round(currentDevice.autorunEngineDelayInSeconds / 60)} readOnly />
            <span className="duration-note">
              {t('dashboard-sidebar:min')}
            </span>
          </div>
          <div className="note">
            {t('dashboard-sidebar:engineWorkTime')}
          </div>
          <a
            onClick={e => setSeconds(e, false)}
            className={cx('plus quantity-btn', { disable: currentDevice.autorunEngineDelayInSeconds === 1800 })}
          />
          {currentDevice.canWebasto
            ? <div className="info__set__service">
              <div className="info__set__service__note">
                <h3>
                  {t('dashboard-sidebar:preheating')}
                  <span className="hint">
                      ?<span className="right">{t('dashboard-sidebar:preheatingDescription')}</span>
                  </span>
                </h3>
              </div>
              <div className="info__set__service__check">
                <label className="switch" htmlFor="setwebasto">
                  <input id="setwebasto" onChange={e => setWebastoOn(e)} type="checkbox" />
                  <span className="slider" />
                </label>
              </div>
            </div>
            : null}
        </div>
      </div>
    );
  }
}

IgnitionAutorun.WrappedComponent.propTypes = {
  t: PropTypes.func.isRequired,
};

IgnitionAutorun.propTypes = {
  currentDevice: PropTypes.shape({
    canWebasto: PropTypes.bool,
  }).isRequired,
  onClickOutside: PropTypes.func.isRequired,
  setWebastoOn: PropTypes.func.isRequired,
  setSeconds: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/DeviceControl/Ignition/IgnitionAutorun.js